module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/svg/svg.component.scss
// module id = ./src/app/svg/svg.component.scss
// module chunks = main